<script>
export default {
  page: {
    title: 'Health Action Result',
    meta: [{ name: 'description', content: 'The Health Action Result page.' }],
  },

  data() {
    return {
      type: '',
      userData: null,
      orgName: '',
    }
  },
  computed: {
    isTelehealth() {
      const features = this.$store.state.profileQuestions.features.health_help
      const teleHealth = features.find(
        (feature) => feature.feature_route === 'telehealth'
      )
      if (teleHealth) return teleHealth.feature_status === 'active'
      else return false
    },
  },
  async mounted() {
    this.userData = this.$store.state.auth.currentUser
    this.orgName = this.userData.user.user_org_details[0].org_name
  },
  created() {
    this.type = this.$route?.path.split('/')[3]
  },
  methods: {
    navigateTo(routerName, params) {
      this.$router.push({
        name: routerName,
        params:
          routerName === 'health-help' ? { showQuestinnarie: false } : params,
      })
    },
    openNewIsabelSymptomChecker() {
      window.open(
        'https://symptomchecker.isabelhealthcare.com/index.jsp?passcode=CJK0Xj6NCaVeDIp6tpK3op7Q4Yl5Kv2S'
      )
    },
  },
}
</script>

<template>
  <div class="ma-auto">
    <v-container class="d-flex" :class="$style.questionWrapp">
      <v-row :class="[[$vuetify.breakpoint.mobile ? 'mx-0' : 'mx-5']]">
        <v-col cols="12" sm="12" md="12" lg="12" xl="12">
          <h3
            :class="[
              $style.pageTitle,
              [$vuetify.breakpoint.mobile ? 'mb-2' : 'mb-5'],
            ]"
            >Your next best health action...</h3
          >
        </v-col>
        <v-col cols="12" xs="12" sm="4" md="4" lg="2" xl="2" class="pa-0">
          <v-img
            height="122"
            contain
            :src="require('@assets/images/safehaven/health-survey/Results.svg')"
          ></v-img>
        </v-col>
        <v-col
          cols="12"
          xs="12"
          sm="8"
          md="8"
          lg="10"
          xl="10"
          class="pl-4 pa-0"
        >
          <div v-if="this.$route.params.action === 'A'">
            <h6 :class="$style.sectionTitle" class="mb-3">
              Thanks for your responses!
            </h6>
            <p :class="[$style.paraClass, 'pa-1']">
              If you ever experience symptoms of depression, you can proceed to
              <a :class="$style.linkClss" @click="openNewIsabelSymptomChecker">
                Health Check
              </a>
              and share this information with your healthcare provider.
            </p>
          </div>
          <div
            v-else-if="
              this.$route.params.action === 'B1' ||
              this.$route.params.action === 'B2'
            "
          >
            <h6 :class="$style.sectionTitle" class="mb-3">
              Based on available data, you do not appear to be suffering from
              depression.
            </h6>
            <p :class="[$style.paraClass, 'pa-1']">
              However, if you ever experience symptoms of depression please
              repeat this questionnaire, use the Instant Health Checker and
              share the results with your provider, or speak directly with your
              provider.
            </p>
            <p class="pa-1">
              <a
                :class="$style.linkClss"
                target="_blank"
                href="https://symptomchecker.isabelhealthcare.com/index.jsp?passcode=CJK0Xj6NCaVeDIp6tpK3op7Q4Yl5Kv2S"
              >
                Go to Instant Health Checker
              </a>
            </p>
          </div>
          <div v-else-if="this.$route.params.action === 'C'">
            <h6 :class="$style.sectionTitle" class="mb-3">
              Based on available data, you may be suffering from mild to
              moderate depression.
            </h6>
            <p :class="[$style.paraClass, 'pa-1']">
              We suggest consulting with a mental health professional or your
              primary care provider. Seeking help early for a mental health
              issue can make a big difference.
            </p>
            <div v-if="isTelehealth">
              <p :class="[$style.paraClass, 'pa-1']">
                Your membership plan includes telehealth. Search our list of
                providers to schedule an appointment.
              </p>
              <v-btn
                :class="['primary-btn', 'mb-4']"
                @click="() => navigateTo('telehealth')"
                >Schedule telehealth appointment</v-btn
              >
            </div>
            <p :class="[$style.paraClass, 'pa-1']"
              >If you are having suicidal thoughts, please call the Suicide and
              Crisis hotline at 988.
            </p>
            <p :class="[$style.paraClass, 'pa-1']"
              >If you are experiencing an emergency, please call 911.
            </p>
          </div>
          <div v-else-if="this.$route.params.action === 'D'">
            <h6 :class="$style.sectionTitle" class="mb-3"
              >Based on available data, you may be suffering from severe
              depression.
            </h6>
            <p :class="[$style.paraClass, 'pa-1']">
              You should consult immediately with a mental health professional
              or your primary care provider.
              <strong
                >If you are having suicidal thoughts, please call the Suicide
                and Crisis hotline at 988.</strong
              >
            </p>
            <div v-if="isTelehealth">
              <p :class="[$style.paraClass, 'pa-1']">
                Your membership plan includes telehealth. Search our list of
                providers to schedule an appointment.
              </p>
              <v-btn
                :class="['primary-btn', 'mb-4']"
                @click="() => navigateTo('telehealth')"
                >Schedule telehealth appointment</v-btn
              >
            </div>
            <p :class="[$style.paraClass, 'pa-1']"
              ><strong
                >If you are experiencing an emergency, please call 911.</strong
              >
            </p>
          </div>
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="12" xl="12">
          <p :class="[$style.paraClassContent, 'mr-3', 'pa-1']" class="mb-0">
            HealthBook+ provides information to help guide your next action
            based on available data about your symptoms and conditions.
            HealthBook+ does not provide a medical diagnosis and should not
            replace licensed healthcare practitioners. If you have any questions
            or concerns about the results of HealthBook+, consult your licensed
            healthcare practitioner.
          </p>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.btnClass {
  min-width: 338px !important;
  padding: 28px 68px !important;
  margin: 15px 0 25px;
  color: #fff !important;
  text-transform: capitalize;
  background-color: #0476d9 !important;
  border-radius: 30px;
}
.questionWrapp {
  width: 726px;
  padding: 30px;
  background-color: #fff !important;
  border: 1px solid #93c0e8;
  border-radius: 4px;
}
.pageTitle {
  font-size: 18px;
  font-weight: 700;
  line-height: 120%;
  color: #454648;
}
.sectionTitle {
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  color: #454648;
}
.paraClass {
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  color: #454648;
}
.paraClassContent {
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  color: #454648;
}
.linkClss {
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
  color: #057cfc;
  text-decoration: none;
}
.orgName {
  text-transform: capitalize;
}
.btnMobileClass {
  width: 100% !important;
  padding: 28px 68px !important;
  margin: 10px 0 15px;
  color: #fff !important;
  text-transform: capitalize;
  background-color: #0476d9 !important;
  border-radius: 30px;
}
@media screen and (max-width: 1263px) {
  .questionWrapp {
    width: 90%;
    padding: 20px;
  }
}
@media screen and (max-width: 320px) {
  .btnMobileClass {
    font-size: 12px !important;
  }
}
</style>
